
import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import HorarioIcon from "../../assets/icons/horario.png";
import HorariosService from "../../services/HorariosService";

export default function HorariosForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idHorario: null,
    diaSemana: "",
    dia: "",
    horario: "",
    ativo: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idHorario: null,
        diaSemana: "",
        dia: "",
        horario: "",
        ativo: false,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idHorario:itemSelecionado.IDHORARIO,
        diaSemana: itemSelecionado.DIA_SEMANA,
        dia: itemSelecionado.DIA,
        horario: itemSelecionado.HORARIO,
        ativo: itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (form.diaSemana === "") e.diaSemana = "Informe o dia da semana";
    if (!form.dia) e.dia = "Informe o dia";
    if (!form.horario) e.horario = "Informe o horário";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {
        setRetorno({
          tipo: "erro",
          mensagem: "Função desabilitada!",
        });
        setSubmitState("ERROR");
      }

      if (modo === "alterar") {
        const payload_update = { 
          ATIVO: form.ativo
      };

      await HorariosService.update(form.idHorario, payload_update);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Horário atualizado com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar horário."
            : "Erro ao atualizar horário.",
      });

      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={HorarioIcon} alt="" className="icon" />
          {modo === "novo" ? "Cadastro de Horário" : "Alterar Horário"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Dia da Semana: *</div>
            <input type="text" value={form.dia} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Horário: *</div>
            <input type="text" value={form.horario.slice(0,5)}  disabled />
        </div>

        {modo === "novo" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
              <input type="text" disabled />
          </div> 
        )}

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select
              name="ativo"
              value={String(form.ativo)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value='1'>Sim</option>
              <option value='0'>Não</option>
            </select>
          </div> 
        )}

        <div className="Form-Interno-alinhamento-button">

          {modo === "novo" && (
            <div /*type="submit" disabled={loading}*/
              className="Form-Interno-alinhamento-button-inativo" >
              {/*loading ? "Enviando..." : "Salvar"*/}
              <Link to="/Gerenciamento">Inativo</Link>
            </div>
          )}

          {modo === "alterar" && (
            <button type="submit" disabled={loading} className="Form-Interno-button">
              {loading ? "Enviando..." : "Salvar"}
            </button>
          )}

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
